import React, { Component } from 'react';
import Form from './components/register/Form';
import 'sweetalert/dist/sweetalert.css';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';
import WaitingModal from '../generics/WaitingModal';
import Notifications, {notify} from 'react-notify-toast';
import swal from 'sweetalert';
import moment from 'moment';
import 'sweetalert/dist/sweetalert.css';

var Config = require('../../config');

const style = {
  margin: 7,
};

class OffersNew extends Component{
	constructor(props) {
	    super(props);
	    this.saveItem = this.saveItem.bind(this);
	    this.cancel = this.cancel.bind(this);
	    this.isValidAge = this.isValidAge.bind(this);
	    this.finish = this.finish.bind(this);
		this.disableElementsView = this.disableElementsView.bind(this);
		this.getPatientNumber = this.getPatientNumber.bind(this);
     
	    this.state = {
	    	saved:false,
	    	alerts_age_donor:{},
	    	show_promotion:false,
	    };
	}
   
	componentDidMount(){
		//this.getPatientNumber();
		
		this.form.state.label="Firma del Donador";
		if(this.props.match.params.preoffer_id !== undefined){
			fetch(Config.default.apiGateway.URL+'pre_offers/'+this.props.match.params.preoffer_id,{ 
			    method: 'get',
			    headers: new Headers({
			       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			       'Accept': 'application/json',
			       'Content-Type': 'application/json',
			    })
			})
			.then(response => response.json())
			.then(response => {
				this.getDonationType(response.pre_offers.donation_type_extraction_id);

				setTimeout(()=>{
					this.form.setState({
						donor_id:response.donor_id,
						patient_id:response.patient_id,
						convoke_places_id:response.pre_offers.convoke_places_id, 
						donation_type_extraction_id:response.pre_offers.donation_type_extraction_id,
						day_sesion_donation:response.pre_offers.work_session_id,
						timestamp_hour:moment(response.pre_offers.timestamp_hour, 'H:mm:ss').format('HH:mm'),
						timestamp_date:moment(response.pre_offers.timestamp_date).format('DD/MM/YYYY'),
						timestamp:moment(response.pre_offers.timestamp_date).format('DD/MM/YYYY')+' '+moment(response.pre_offers.timestamp_hour, 'H:mm:ss').format('HH:mm'),
						donation_type_id:response.pre_offers.donation_type_id,
						donor_person_id:response.pre_offers.person_donor_id,
						pre_offers_id:response.pre_offers.id,
						patient_person_id:response.pre_offers.person_patient_id
					});

					this.form.setState({
						relationship:response.pre_offers.patient_relationship,
						national_center_id:response.pre_offers.national_center_id,
						national_name:response.pre_offers.patient_section_name,
						emergency_level: response.pre_offers.emergency_level
					});
					

					if(response.pre_offers.person_patient_id !== null){
						this.form.setState({show_patient_data: true});

						var item = {person:response.person1, patient:{id:"", observations:"", number:""}}
						if(response.patient_id !== 0){
							item.patient.id = response.patient_id;
						}					
						this.form.setInfoPatient(item);

						
						
					}else{
						this.form.setState({show_patient_data: false});
					}



					var obj = {
						person:response.person, 
						donor:response.pre_offers, 
						address:response.address,
						document:{document:response.documents !== undefined ? response.documents[0] : null}
					};

					if(response.donor_id !== 0){
						this.form.getInfo(response.donor_id);

					}else{
						obj.donor.id = "";
						this.form.setInfoDonor(obj);
					}
				}, 500);

									
			})
		}

		if(this.props.location.pathname.indexOf('promotion') !== -1){
			this.setState({show_promotion:true});
		}
		
	}

	getPatientNumber(){
		fetch(Config.default.apiGateway.URL+'patients/next_patient_number', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.form.setState({patient_number: response})
			}
		})
	}

	getDonationType(id){
		if(id !== null){
			fetch(Config.default.apiGateway.URL+'donation_rules?option=donation_extraction&donation_extraction_id='+id,{ 
				method: 'get',
				headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
					'Content-Type': 'application/json',
				})
			})
			.then(response => response.json())
			.then(response => {
				this.form.offer.setState({
				donation_types: response
				});
			});
		}
	}

	componentWillMount() {
		
    	//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=ALERTS_AGE_DONOR',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      alerts_age_donor: response
		    });
		})	
  	}

	cancel(e){
		this.props.history.push(
			this.state.show_promotion ? "/promotion/offers" : "/register"
		);
	}

	//Funcion Submit Form
	async saveItem(e){
		e.preventDefault();

		var validForm = await this.isValidForm();
    	if(validForm) {
    		if (this.isValidaDate(this.form.state.birthday)){
    			
    			if(this.form.state.stats.reject_process !== null){
    				if(this.form.state.stats.reject_process.toLowerCase() === 'clinic_history'){
		    			swal('¡Error!','El donador tiene historial clínico de rechazo','error');
		    			return;
		    		}else if(this.form.state.stats.reject_process.toLowerCase() === 'laboratory'){
		    			swal('¡Error!','No puede donar, consultar con Laboratorio','error');
		    			return;
		    		}
    			}else{
    				swal('¡Error!', 'El donador tiene estatus de rechazo', 'error');
    				return;
    			}
	    		
				var obj = {};
				var error = '';
	    		obj.answers = this.form.getAnswers();
		      	obj.offer = this.form.getOffer();
		      	obj.person = this.form.getPerson();
		      	obj.donor = this.form.getDonor();
		      	obj.address = this.form.getAddress();
		      	obj.photo = this.form.getPhoto();
		      	obj.fingerprint =this.form.getFingerprint();
		      	obj.fingerprint_img = this.form.getFingerprintImg();
		      	obj.caller_id = this.props.match.params.caller_id;
		      	obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
				obj.incident=0;
				obj.person_signature = this.form.state.person_signature;

				/*if(this.form.state.error_email !== ""){
					error = 'Correo electrónico no tiene un formato correcto';
				}*/
				
				var index = this.form.state.fields.findIndex(obj => 
					obj.key === 'DONOR_PHONE' && obj.required
				);

				if(index !== -1){
					if(obj.person.phones.length === 0){
						error = "Debe agregar por lo menos un número de teléfono";
					}
				}

				var mpio = document.getElementById('MUNICIPIO');
				if(mpio  !== null){
					if(mpio.value !== "" && obj.address.municipio === ""){
						error = 'No se seleccionó un municipio del catálogo';
						document.getElementById('MUNICIPIO').classList.add('error');
					}
				}
				
				

		      	if (this.form.state.show_patient_data === true) {
					obj.person_patient = this.form.getPersonPatient();
					if(obj.person_patient.birthday !== ""){
						if(!this.isValidaDate(obj.person_patient.birthday.split(/\//).reverse().join('/'))){
							error = 'Fecha de nacimiento de paciente es incorrecta';
						}else{
							//obj.person_patient.birthday = obj.person_patient.birthday.split(/\//).reverse().join('/');
						}
					}
					  
				};

				if(error === ''){
					if(this.isValidAge(obj) === true){
						this.postOffer(obj);
					}
				}else{
					notify.show('Error, '+error,'error');
				}

					
		    }else{
				notify.show('Error, Fecha de Nacimiento no válida','error');
		    }			
	    } else {
	    	notify.show('Error, Campos Incompletos','error');
	    }
	}

	isValidaDate(fecha){
		//if(document.getElementById('birthday').required){
		if(fecha.indexOf('_') === -1){
			var arr = fecha.toString().split("/");
			for(var i=0; i< arr.length;i++){
				if (!/^([0-9])*$/.test(arr[i]))
					return false;
			}
		
			var fecha_aux = new Date(fecha.split(/\//).reverse().join('/'));
			if(fecha_aux.toString() === 'Invalid Date')
				return false;

			return true;
		}else{
			return false;
		}
			
		//}else{
		//	return true;
		//}	
	}

	isValidAge(obj){
		var items = this.form.offer.state.donation_types;
		var donation_type_id = obj.offer.donation_type_id;
		var res = true;
		for(var i =0; i < items.length;i++){
			if(parseInt(donation_type_id,10) === items[i].rules.donation_type_id){
				//Si la edad del donante no esta en el rango valido de donacion
				if(obj.offer.donor_age  < items[i].rules.age_min || obj.offer.donor_age > items[i].rules.age_max){
					if(this.state.alerts_age_donor.value === "YES"){
						swal({
				        title: '¡Valores fuera de rango! \n ¿Desea guardar?',
				        text: "La edad de donacion permitida es de "+items[i].rules.age_min+' a '+items[i].rules.age_max+" años",
				        type: 'warning',
				        showCancelButton: true,
				        confirmButtonColor: '#DD6B55',
				        confirmButtonText: '¡Si, Continuar!',
				        cancelButtonText: '¡No, Cancelar!',
				        closeOnConfirm: true,
				        closeOnCancel: true,
				    }, function (isConfirm) {
				        if (isConfirm) {
				        	obj.incident = 1;
				        	this.postOffer(obj);
				        	return true;
				        }else{
				        	return false;
				        }
				    }.bind(this));
					}else{
						swal({
					        title: 'No es posible guardar',
					        text: "La edad de donación permitida es de "+items[i].rules.age_min+' a '+items[i].rules.age_max+" años",
					        type: 'error'
					    });
					}
					res = false;
				}
			}
		}
		return res;
	}

	validBirthdate(){
		var aux_date = new Date();
		var hoy = aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2);
		hoy = moment(hoy);
		var birth = moment(this.form.state.birthday,'DD-MM-YYYY');
		var date_ok = true;

		if(hoy !== 'Invalid date' && birth !== 'Invalid date'){
			
			if(hoy < birth){
				date_ok = false;
			}
		}else{
			date_ok = false;
		}		

		return date_ok;

	}

	postOffer(obj){
		console.log(obj)
		if(this.validBirthdate()){
			this.waiting_modal.handleShow('Guardando...');
	      	fetch(Config.default.apiGateway.URL+'offers', {
			  method: 'POST', // or 'PUT'
			  body: JSON.stringify(obj), // data can be `string` or {object}!
			  headers: new Headers({
			  	'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
			  	'Accept': 'application/json',
			  	'Content-Type': 'application/json;charset=UTF-8'
			  })
			})
			.then(res => {
				this.waiting_modal.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then(function(result) {
					swal('¡Error!', result, 'error');
					});
			}})
			.then(response => {
		    	if(response !== undefined){
		    		notify.show('Registro Guardado','success');

					if(response.extraction_type !== undefined){
						if(response.extraction_type.donation_type_process !== null){
							this.form.setState({stats:{
								last_donation_date:"",
								donation_type:"",
								extraction_type: response.extraction_type.donation_type_process,
								total_donations:0,
								total_last_year:0,
								total_offers:0,
								lookup_group:"",
								lookup_rh:"",
								temporality:"",
								total_hc:0,
								reject_process:"",
								error_email:""
								
							}});	
						}						
					}
					
		    		this.form.setOfferId(response.id,response.donor.id, response.donor.donor_number);
		    		this.setState({saved:true});
					sessionStorage.removeItem('indice_rejection');
		sessionStorage.removeItem('rejection_days');
		sessionStorage.removeItem('rejection_description');
		    	}else{
		    		notify.show('Error, No se pudo guardar','error');
		    	}
			});
		}else{
			swal('Error', 'La Fecha de Nacimiento no puede ser mayor a la fecha de hoy', 'error');
		}
			
	}

	//Verificar si el formulario es valido
	async isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    var vacio = false;

		//Validar que realemente seleccionen un hospital para el paciente
		if(this.form.patient !== undefined && this.form.patient !== null){
			if(this.form.patient.state.requestedSelected.length === 0){
				await this.form.patient.refs._handleSearch_nc._instance.clear();
			}
		}

	    await inputs.forEach(input => {
	    	if(input.id === 'state'){
	    		input.id = 'ESTADO';
			}
			
			var index = -1;
	    	/*var index = this.form.state.required_fields.findIndex(obj => 
	    		obj.field.toUpperCase() === input.id.toUpperCase()
	    	);*/


	    	if(index !== -1){

	    		//if(this.form.state.required_fields[index].required){
					
	    			var control = document.getElementById(input.id);

	    			if(control !== null){
	    				if(control.value === ""){
							control.classList.add('error');
				        	//isFormValid = false;
				        	vacio = true;
				        	
						}else{
							if(control.className.includes('error')){
								control.classList.remove('error');
								//isFormValid = isFormValid ? true : false;
							}
						}

	    			}
	    		//}
	    	}else{
	    		if(input.required){
					
					  const isInputValid = this.form.showCtrlError(input.id);
					  
			      	if (!isInputValid) {
			        	vacio = true;
			    	}
			  	}
	    	}

	    });

	    if(vacio){
	    	return false;
	    }

	    return isFormValid;
	}

	finish(){
		fetch(Config.default.apiGateway.URL+'caller_actions_history?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+"&message=new_offer_added", {
		  method: 'get', // or 'PUT'
		  headers: new Headers({
		  	'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
		  	'Accept': 'application/json',
		  	'Content-Type': 'application/json;charset=UTF-8'
		  })
		})
		.then(response => {
	    	this.props.history.push(
				this.state.show_promotion ? "/promotion/offers" : "/register"
			);
		});	
	}

	disableElementsView(){
		const inputs = document.querySelectorAll('select,input, button');

	    inputs.forEach(input => {
	    	var control = document.getElementById(input.name);
	    	if(control !== null)
	    		control.setAttribute("disabled","disabled");
	    	else
	    		input.setAttribute("disabled", true);
	    });
	}

	//Contenido de la pantalla para el alta de un nuevo registro
	render(){
		const { t } = this.props;
        return(
			<div className="col-xs-12">
				<div>
					<div className="route">
						<h5 className="title_page" >
							{sessionStorage.getItem('health_facilities_name')} ->
					        Donantes -> 
					        Ofrecimiento
						</h5> 
					</div>
				</div>
			
		        <form noValidate>	
				
		        	<Form {...this.props} onRef={ref => (this.form = ref)} 
					    
						disableElementsView={this.disableElementsView}
						getPatientNumber={this.getPatientNumber}
		        		agenda={false} show_promotion={this.state.show_promotion}/>
						
		        	<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
					
		        	<Notifications />
						
					
		        </form>
		        <div className="col-xs-12">
		        	{!this.state.saved?
		        	<div className="col-xs-12 col-sm-9" style={{textAlign:'center'}}>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} 
		        			onClick={this.saveItem} style={style}/>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.reset')} 
		        			onClick={this.cancel} style={style}/>
		        	</div>
		        	:<div className="col-xs-12 col-sm-9" style={{textAlign:'center'}}>
		        		<RaisedButton label={t('content.generics.buttons.finish')} 
		        			className="action-btn" onClick={this.finish} style={style}/>
		        	</div>	
		        	}
					
		        </div>
			
		    </div>
		);
	}
}

export default translate('translations')(OffersNew)